'use strict';
/**
 *  Navigation
 * @description import navigation types & check if they are already imported & initialized
 */

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Capitan from '../../../code/js/Capitan/Capitan';
import existClass from './helper/existClass';

var Navigation = function Navigation() {
  var _ = {
    defaults: {
      classes: {
        mobile: 'nav-mobile',
        desktop: 'nav-desktop'
      },
      states: {
        init: 'js-init',
        openMobile: 'is-nav-mobile-open'
      }
    }
  };
  var o = _.defaults;
  /**
   * Navigation init
   * @description check if Navigation (Desktop|Mobile) is already initialized & init Navigation type if not
   * @return component
   */

  var init = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var initMobile, initDesktop;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Check if navigations are already initialized
              initMobile = existClass(o.classes.mobile, o.states.init), initDesktop = existClass(o.classes.desktop, o.states.init);
              resetAllNavigationStates(); // Import Mobile Navigation

              if (!(!initMobile && (Capitan.assertBreakpoint('lt', 'lg') || Capitan.assertBreakpoint('eq', 'lg')))) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", import(
              /* webpackChunkName: "nav-mobile" */
              './navigationMobile').then(function (component) {
                return component;
              }));

            case 4:
              if (!(!initDesktop && Capitan.assertBreakpoint('ht', 'lg'))) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", import(
              /* webpackChunkName: "nav-desktop" */
              './navigationDesktop').then(function (component) {
                return component;
              }));

            case 6:
              return _context.abrupt("return", undefined);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function init() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * Set Initial Class
   * @description sets class 'js-init' on 'nav-mobile' or 'nav-desktop' DOM Objects
   * @return currentComponent
   */


  var setInitialClass = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currentComponent;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return init().then(function (component) {
                // console.log('init', component);
                currentComponent = component;
                document.getElementsByClassName(component.default().getComponent())[0].classList.add(o.states.init);
              });

            case 3:
              _context2.next = 7;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);

            case 7:
              return _context2.abrupt("return", currentComponent);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 5]]);
    }));

    return function setInitialClass() {
      return _ref2.apply(this, arguments);
    };
  }();

  var resetAllNavigationStates = function resetAllNavigationStates() {
    // Close Mobile Navigation on entering Desktop Viewport
    Capitan.assertBreakpoint('ht', 'md');
    document.body.classList.remove(o.states.openMobile);
  };

  return Object.freeze({
    init: init,
    setInitialClass: setInitialClass
  });
};

export default Navigation;